export const printChecklist = (steps, checked) => {
  const done = Object.values(checked).filter(Boolean).length;
  const total = steps.reduce((n, s) => n + s.checklist.length, 0);
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

  const chapters = steps
    .map(
      (s) => `
      <div class="chapter">
        <div class="chapter-head">
          <span class="num">${s.number}</span>
          <div>
            <h2>${s.title}</h2>
            <p class="sub">${s.subtitle}</p>
          </div>
        </div>
        <ul>
          ${s.checklist
            .map((item, j) => {
              const isDone = !!checked[`${s.id}-${j}`];
              return `<li class="${isDone ? "done" : ""}"><span class="box">${isDone ? "✓" : ""}</span><span>${item}</span></li>`;
            })
            .join("")}
        </ul>
      </div>`
    )
    .join("");

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" />
<title>Hijrah Mom — The Roadmap Checklist</title>
<style>
  @page { margin: 18mm; }
  * { box-sizing: border-box; }
  body { font-family: Georgia, 'Times New Roman', serif; color: #1A2E26; margin: 0; background: #fff; }
  .header { border-bottom: 3px double #D9777F; padding-bottom: 14px; margin-bottom: 6px; }
  .brand { font-style: italic; font-size: 26px; color: #1B4D3E; }
  .brand span { color: #D9777F; }
  h1 { font-size: 21px; margin: 10px 0 4px; color: #1A2E26; }
  .meta { font-family: monospace; font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #8A9B93; }
  .progress { margin: 12px 0 22px; font-size: 13px; color: #4A5D55; }
  .progress strong { color: #D9777F; }
  .chapter { break-inside: avoid; border: 1px solid #e8dcd0; border-radius: 10px; padding: 16px 18px; margin-bottom: 14px; }
  .chapter-head { display: flex; gap: 14px; align-items: baseline; margin-bottom: 10px; }
  .num { font-size: 24px; font-weight: bold; color: #D9777F; }
  h2 { font-size: 17px; margin: 0; color: #1B4D3E; }
  .sub { font-size: 12px; color: #8A9B93; margin: 2px 0 0; font-style: italic; }
  ul { list-style: none; margin: 0; padding: 0; }
  li { display: flex; gap: 10px; align-items: flex-start; font-size: 13px; padding: 5px 0; border-bottom: 1px dotted #eee; }
  li:last-child { border-bottom: none; }
  .box { width: 14px; height: 14px; border: 1.5px solid #1B4D3E; border-radius: 3px; flex-shrink: 0; margin-top: 1px; text-align: center; line-height: 12px; font-size: 10px; color: #D9777F; }
  li.done span:last-child { text-decoration: line-through; color: #8A9B93; }
  .footer { margin-top: 20px; padding-top: 12px; border-top: 1px solid #e8dcd0; font-size: 11px; color: #8A9B93; font-style: italic; line-height: 1.6; }
</style>
</head>
<body>
  <div class="header">
    <div class="brand">Hijrah <span>Mom</span></div>
    <h1>The Roadmap Checklist — from niyyah to one-way ticket</h1>
    <div class="meta">Printed ${date} · hijrah mom field guide</div>
  </div>
  <p class="progress">Progress so far: <strong>${done} of ${total}</strong> items complete. Bismillah — one box at a time.</p>
  ${chapters}
  <div class="footer">
    This checklist is experience, not legal advice. Custody and immigration questions deserve a licensed attorney and an accredited embassy — and every big decision deserves istikhara. May Allah make your hijrah easy and full of barakah.
  </div>
</body>
</html>`;

  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 350);
};

export const printPacking = (country, groups) => {
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const sections = groups
    .map(
      ([title, items]) => `
      <div class="group">
        <h2>${title}</h2>
        <ul>
          ${items.map((it) => `<li><span class="box"></span><span>${it}</span></li>`).join("")}
        </ul>
      </div>`
    )
    .join("");

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" />
<title>Hijrah Mom — ${country.name} Packing List</title>
<style>
  @page { margin: 18mm; }
  * { box-sizing: border-box; }
  body { font-family: Georgia, 'Times New Roman', serif; color: #1A2E26; margin: 0; background: #fff; }
  .header { border-bottom: 3px double #D9777F; padding-bottom: 14px; margin-bottom: 16px; }
  .brand { font-style: italic; font-size: 26px; color: #1B4D3E; }
  .brand span { color: #D9777F; }
  h1 { font-size: 21px; margin: 10px 0 4px; }
  .meta { font-family: monospace; font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #8A9B93; }
  .climate { font-style: italic; color: #4A5D55; font-size: 13px; margin: 0 0 18px; }
  .group { break-inside: avoid; border: 1px solid #e8dcd0; border-radius: 10px; padding: 14px 18px; margin-bottom: 14px; }
  h2 { font-size: 15px; color: #1B4D3E; margin: 0 0 8px; }
  ul { list-style: none; margin: 0; padding: 0; }
  li { display: flex; gap: 10px; align-items: flex-start; font-size: 13px; padding: 5px 0; border-bottom: 1px dotted #eee; }
  li:last-child { border-bottom: none; }
  .box { width: 14px; height: 14px; border: 1.5px solid #1B4D3E; border-radius: 3px; flex-shrink: 0; margin-top: 1px; }
  .footer { margin-top: 18px; padding-top: 12px; border-top: 1px solid #e8dcd0; font-size: 11px; color: #8A9B93; font-style: italic; }
</style>
</head>
<body>
  <div class="header">
    <div class="brand">Hijrah <span>Mom</span></div>
    <h1>${country.name} Packing List — for mom & the kids</h1>
    <div class="meta">Printed ${date} · hijrah mom field guide</div>
  </div>
  <p class="climate">${country.climateNote}</p>
  ${sections}
  <div class="footer">Ship less, smile more: if it costs less to replace than to ship, leave it. May your suitcases be light and your arrival full of barakah.</div>
</body>
</html>`;

  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 350);
};
